import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';

export interface GetContactsCountResponse {
  count: number;
}

export function getContactsCount() {
  return requestApi<GetContactsCountResponse>({
    url: withDocument('/address-book/contacts/count'),
    method: 'GET',
    credentials: true,
  }).then((response) => response.data);
}
